import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-light-svg-icons'

import LoadingBubbles from 'components/LoadingBubbles'

import styles from './styles.scss'

const Modal = (props) => {
  const {
    children,
    closeIcon,
    closeModalCallback,
    dialogStyle,
    loading,
    mobileVersion,
    showModal,
    title,
    titleStyle,
  } = props

  const dialogClassName = mobileVersion ? classnames(styles.modalDialog, styles.mobile) : styles.modalDialog

  if (showModal){
    return (
      <div className={styles.fullScreenModal}>
        <div className={dialogClassName} style={dialogStyle}>
          <div className={styles.modalHeader}>
            <h4 className={styles.title} style={titleStyle}>
              {title} {loading && <LoadingBubbles />}
            </h4>
            <a data-test-id="modalCloseButton" tabIndex="0" onClick={closeModalCallback} className={styles.closeModal}>
              {closeIcon || <FontAwesomeIcon icon={faTimes} />}
            </a>
          </div>
          {children}
        </div>
      </div>
    )
  }

  return false
}

Modal.propTypes = {
  children: PropTypes.node,
  closeIcon: PropTypes.node,
  closeModalCallback: PropTypes.func,
  dialogStyle: PropTypes.object,
  loading: PropTypes.bool,
  mobileVersion: PropTypes.bool,
  showModal: PropTypes.bool,
  title: PropTypes.string,
  titleStyle: PropTypes.object,
}

Modal.defaultProps = {
  dialogStyle: {},
  showModal: false,
  mobileVersion: false,
  title: 'Modal',
  titleStyle: {},
}

export default Modal
